// extracted by css-extract-rspack-plugin
export default {"enterprise":"CalculatorEnterprise-module__enterprise--C8xda","title":"CalculatorEnterprise-module__title--e1aBe","text":"CalculatorEnterprise-module__text--mlP3Q"};